define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi",
	"csi/_base/underscore",
	"csi/xml",
	"ProductSpec/SizeChart",
	"ProductSpec/SizeChart/Number"
], function(declare,lang,domClass,csi,_,xml,SizeChart,NumberRen) {

	return declare(NumberRen, {
		bBaseRenderer: true,

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: show Absolutes value
			return ctx.getNode().Absolutes[ctx.keyValue];
		}
	});
});